<template>
  <div class="text-center">
    <v-dialog v-model="dialog" max-width="720" persistent>
      <v-card class="nc-card">
        <v-card-title class="nc-hero py-3">
          <div class="d-flex align-center" style="gap: 12px;">
            <v-avatar color="white" size="40" class="elevation-1">
              <v-icon color="deep-orange darken-3">mdi-account-plus</v-icon>
            </v-avatar>
            <div>
              <div class="text-h6 white--text">Nuevo contacto</div>
              <div class="text-body-2 white--text">Registra un contacto y conviértelo en prospecto</div>
            </div>
          </div>
        </v-card-title>

        <v-card-text class="pt-4">
          <v-row dense>
            <v-col cols="12" md="6">
              <v-text-field
                label="* Nombres"
                v-model="nombres"
                outlined
                dense
                type="text"
                prepend-inner-icon="mdi-account"
                placeholder="Ej. Ana Maria"
              />
            </v-col>
            <v-col cols="12" md="6">
              <v-text-field
                label="* Apellidos"
                v-model="apellidos"
                outlined
                dense
                type="text"
                prepend-inner-icon="mdi-account"
                placeholder="Ej. Perez Lopez"
              />
            </v-col>
            <v-col cols="12" md="6">
              <v-combobox
                v-model="origen"
                :items="origenes"
                :loading="isloadingestudent"
                item-text="nombre"
                label="* Origen del contacto"
                loader-height="6"
                outlined
                dense
                prepend-inner-icon="mdi-source-branch"
              />
            </v-col>
            <v-col cols="12" md="6">
              <v-combobox
                v-model="area"
                :items="areas"
                :loading="isloadingestudent"
                item-text="nombre"
                label="* Area de interes"
                loader-height="6"
                outlined
                dense
                prepend-inner-icon="mdi-target"
              />
            </v-col>
            <v-col cols="12" md="6">
              <v-text-field
                label="* Teléfono"
                v-model="telefono"
                outlined
                dense
                type="text"
                prepend-inner-icon="mdi-phone"
                placeholder="Ej. 70012345"
              />
            </v-col>
            <v-col cols="12" md="6">
              <v-text-field
                label="Correo (opcional)"
                v-model="correo"
                outlined
                dense
                type="email"
                prepend-inner-icon="mdi-email"
                placeholder="Ej. correo@ejemplo.com"
              />
            </v-col>
            <v-col cols="12" md="12">
              <v-autocomplete
                v-model="profesionSeleccionada"
                :items="listaProfesiones"
                item-text="nombre"
                item-value="id"
                label="* Profesión"
                outlined
                dense
                prepend-inner-icon="mdi-briefcase"
                :loading="isLoadingProfesiones"
                clearable
                hide-no-data
                placeholder="Escribe para buscar..."
              />
            </v-col>
            <v-col cols="12">
              <v-text-field
                v-model="filtroprograma"
                label="Programa de interés (opcional)"
                outlined
                dense
                prepend-inner-icon="mdi-school"
                placeholder="Describe el programa de interés..."
                :counter="256"
                maxlength="256"
              />
            </v-col>
          </v-row>
        </v-card-text>

        <v-divider></v-divider>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="grey" text @click="cerrar()">
            Cerrar
          </v-btn>
          <v-btn color="green" class="white--text" :disabled="loading" @click="enviar()">
            <v-icon left small>mdi-check</v-icon>
            Registrar contacto
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <div v-show="false"><ABuscarPersona ref="abuscarpersona" /></div>
  </div>
</template>

<script>
  import ABuscarPersona from '@/components/ABuscarPersona';
  import gql from 'graphql-tag';
  import { getOrigenesContacto, getAreas, createContacto } from './utils';

  export default {
    components: {
      ABuscarPersona,
    },
    data() {
      return {
        loading: true,
        dialog: false,
        isloadingestudent: false,
        filtroprograma: '',
        estudiantes: [],
        filtroestudiante: null,
        origenes: [],
        origen: null,
        areas: [],
        area: null,
        profesionSeleccionada: null,
        listaProfesiones: [],
        isLoadingProfesiones: false,
        timeoutHnd: 0,
        nombres: '',
        apellidos: '',
        telefono: '',
        correo: '',
        new_contacto: {},
      };
    },
    computed: {},
    watch: {
      filtroestudiante: function () {
        if (typeof this.filtroestudiante == 'object') {
          this.setEstudianteSel();
          return;
        }
        if (this.timeoutHnd) {
          clearTimeout(this.timeoutHnd);
          this.timeoutHnd = 0;
        }
        var vue = this;
        this.timeoutHnd = setTimeout(function () {
          if (vue.filtroestudiante.length > 2) {
            vue.estudiantes = [];
            vue.asyncfindestudiante(false);
          } else {
            vue.msg = '';
            vue.estudiantes = [];
          }
          this.timeoutHnd = 0;
        }, 500);
      },
    },
    methods: {
      async openmodal() {
        this.loading = false;
        this.new_contacto = {};
        this.filtroestudiante = null;
        this.origen = null;
        this.area = null;
        this.profesionSeleccionada = null;
        this.filtroprograma = ''
        this.nombres = ''
        this.apellidos = ''
        this.telefono = ''
        this.correo = ''
        this.findOrigenes();
        this.findAreas();
        this.loadProfesiones();
        this.dialog = true;
      },
      cerrar() {
        this.dialog = false;
      },
      async findOrigenes() {
        const res = await getOrigenesContacto();
        this.origenes = res;
      },
      async findAreas() {
        const u = this.$store.state.CARGO.sede.unidad_negocio;
        const res = await getAreas(this, u);
        this.areas = res.getAreas;
      },
      asyncfindestudiante() {
        this.$refs.abuscarpersona.asyncfindestudiante(false, this.filtroestudiante, this);
      },
      setEstudianteSel() {
        if(!this.filtroestudiante) return;

        
        const fil = this.filtroestudiante;
        if (!fil.seg_apellido) fil.seg_apellido = '';
        
        const name = `${fil.nombres} ${fil.pri_apellido} ${fil.seg_apellido}`.trim();
        

        this.new_contacto.persona_id = fil.id;
        this.new_contacto.persona_name = name;
        
      },
      async enviar() {
        if(!this.nombres){
          this.$root.$notify.show('escriba los nombres', { color: 'red', x: 'right' });
          return;
        }
        if(!this.apellidos){
          this.$root.$notify.show('escriba los apellidos', { color: 'red', x: 'right' });
          return;
        }
        if(!this.telefono){
          this.$root.$notify.show('escriba el teléfono', { color: 'red', x: 'right' });
          return;
        }

        if(!this.origen){
          this.$root.$notify.show('selecione el origen', { color: 'red', x: 'right' });
          return;
        }
        if(!this.area){
          this.$root.$notify.show('selecione la area', { color: 'red', x: 'right' });
          return;
        }
        if(!this.profesionSeleccionada){
          this.$root.$notify.show('selecione la profesion', { color: 'red', x: 'right' });
          return;
        }

        const us = this.$store.state.DATA_USER;
        if (!us.seg_apellido) us.seg_apellido = '';
        const us_name = `${us.nombres} ${us.pri_apellido} ${us.seg_apellido}`.trim();
        this.new_contacto.asesor_id = us.id;
        this.new_contacto.asesor_name = us_name;
        this.new_contacto.estado = 'activo';

        this.new_contacto.origen_id = this.origen.id;
        this.new_contacto.area_interes_id = this.area.id;
        this.new_contacto.area_interes_name = this.area.nombre;
        const prof = this.listaProfesiones.find((p) => p.id === this.profesionSeleccionada);
        this.new_contacto.profesion_id = prof ? prof.id : null;
        this.new_contacto.profesion_name = prof ? prof.nombre : '';
        this.new_contacto.nombres = this.nombres;
        this.new_contacto.apellidos = this.apellidos;
        this.new_contacto.telefono = this.telefono;
        this.new_contacto.correo = this.correo;
        this.new_contacto.programa_interes_name = this.filtroprograma || '';

        const res = await createContacto(this.new_contacto);
        window.console.log('res', res);

        if(res && res.id){
          this.$root.$notify.show('registrado :)', { color: 'green', x: 'right' });
          this.cerrar();
        }else if(res && res.error){
          this.$root.$notify.show(res.error, { color: 'red', x: 'right' });
        }else{
          this.$root.$notify.show('algo salio mal :)', { color: 'red', x: 'right' });
        }

        this.$emit('onsuccess');
        this.cerrar();
      },
      async loadProfesiones() {
        if (this.listaProfesiones.length) return;
        this.isLoadingProfesiones = true;
        const sql = gql`query{ getProfesiones(estado:true){ id, nombre } }`;
        try {
          const r = await this.$apollo.query({ query: sql }).then(({ data }) => data);
          this.listaProfesiones = r && r.getProfesiones ? r.getProfesiones : [];
        } catch (e) {
          window.console.error(e);
          this.listaProfesiones = [];
        } finally {
          this.isLoadingProfesiones = false;
        }
      },
    },
    mounted(){}
  };
</script>

<style scoped>
.nc-card {
  border-radius: 14px;
  overflow: hidden;
}
.nc-hero {
  background: linear-gradient(120deg, #ff6a00 0%, #ff3d00 45%, #ffb300 100%);
}
</style>
